export default "__VITE_ASSET__BDVcYR_z__"